import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
const WEBINAR_EMBED_BASE = 'https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478';
const BASE_CST = 'src-gpmax_cmp-mcc_pt-advertorial-4';

/* Every advertorial variant that links here gets its own CST tag, so we can
   tell in the warehouse which article actually drives registrations. Unknown
   values fall back to BASE_CST - never trust the raw query string. */
const KNOWN_VARIANTS = ['spl2', 'art1', 'artkort', 'list'];

/* Fallback when the ?v= parameter is missing, e.g. when Performance Max
   expands to this URL directly. Same-origin navigation sends the full path. */
const REFERRER_VARIANTS: Array<[string, string]> = [['/blog/onzekere-hond-spl2', 'spl2'], ['/blog/onzekere-hond-art1', 'art1'], ['/blog/fout-onzekere-hond-art-kort', 'artkort'], ['/blog/fout-onzekere-hond-list', 'list']];
function resolveVariant(): string | null {
  if (typeof window === 'undefined') return null;
  const fromQuery = new URLSearchParams(window.location.search).get('v');
  if (fromQuery && KNOWN_VARIANTS.includes(fromQuery)) return fromQuery;
  if (document.referrer) {
    try {
      const path = new URL(document.referrer).pathname.replace(/\/+$/, '');
      const match = REFERRER_VARIANTS.find(([prefix]) => prefix === path);
      if (match) return match[1];
    } catch {
      /* malformed referrer, fall through to the base tag */
    }
  }
  return null;
}
function buildEmbedUrl(): string {
  const variant = resolveVariant();
  return `${WEBINAR_EMBED_BASE}?cst=${variant ? `${BASE_CST}-${variant}` : BASE_CST}`;
}
export function WebinarMCAdv4PmaxPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [embedUrl] = useState(buildEmbedUrl);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-4905" data-mp="1etjrmofaqip2">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-4906" data-mp="1joqqnixmez7n">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-4907" data-mp="3awpza8mmkgxt">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-4908" data-mp="3ktkwmo75wbai">
              <XIcon className="w-6 h-6" data-id="element-4909" data-mp="2heln99gohxn" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-4910" data-mp="3ui2uoxo244ag">
              <iframe src={embedUrl} height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-4911" data-mp="ce14xtm530xk"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-4912" data-mp="oos8ns25y1ym">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-4913" data-mp="tooaplravjbj">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-4914" data-mp="ex5ylz1ka8xg" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-4915" data-mp="axdk75phl8k6">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-4916" data-mp="1qckraqmqmemr">
        <div className="flex justify-center md:justify-between items-center" data-id="element-4917" data-mp="1vc74x16h9ww3">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-4918" data-mp="1va33cpw1x9yz" />
          <div className="hidden md:block" data-id="element-4919" data-mp="3ie4bb0g318tz">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-4920" data-mp="3id2qw5d6f9zl">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-4921" data-mp="2znwdmxv5jal6">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-4922" data-mp="2ps2rcmrms2q7">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-4923" data-mp="2ks6o4pqrcfbp">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-4924" data-mp="2pk7gwfu31yqr">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-4925" data-mp="1wvtiw02zv2f7">
        <div className="md:col-span-7" data-id="element-4926" data-mp="21sk0irug662q">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-4927" data-mp="26lvb942dr6zx">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4928" data-mp="193v4364c6oxb">
            Ontdek hoe je met liefdevolle communicatie de onderlinge band met je hond versterkt en problemen voorkomt
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-4929" data-mp="115t8v42v60jy">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-4930" data-mp="n58nc05kdqmr">
            <div className="flex -space-x-3" data-id="element-4931" data-mp="i6fam9y3q3nn">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4932" data-mp="i7gvt78u06j3" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4933" data-mp="28itltkfo3mm7" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4934" data-mp="2b2hvv253day0" />
            </div>
            <div data-id="element-4935" data-mp="263wydah855d9">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-4936" data-mp="263et5ocl3gt7">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-4937" data-mp="2tu0yh7v7emzi">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-4938" data-mp="2ysc8bili0xhq">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes nu gebruiken om door hun hond
            begrepen te worden.
          </p>

          <ul className="space-y-4 mb-8" data-id="element-4939" data-mp="3csd5oo2k1msg">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid bij honden werkelijk betekenen - en de methode die experts gebruiken om hiermee om te gaan', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-4940" data-mp="31suhkqnbiom9" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-4941" data-mp="31vgqoupuxc6l" />
                <span className="text-gray-700 font-medium" data-id="element-4942" data-mp="2wtrfnf2mwyii">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-4943" data-mp="1qc4a7475rqr2">
            <div className="flex -space-x-3" data-id="element-4944" data-mp="1lech46us1yla">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4945" data-mp="x3akn5y533f" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4946" data-mp="auhexoeli1fd" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4947" data-mp="omnup9du66ea" />
            </div>
            <div data-id="element-4948" data-mp="yk2b58zrev6l">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-4949" data-mp="yihg7i9j9a87">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-4950" data-mp="2veoooekh2l1x">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-4951" data-mp="2dbok3dxmh865">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-4952" data-mp="2ddhosnoodibi">
            <div className="flex justify-center items-center w-full" data-id="element-4953" data-mp="2iarmsrq4r2ay">
              <iframe src={embedUrl} height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-4954" data-mp="2n92vv08lp8s4"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-4955" data-mp="3az6nsacffk3a">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4956" data-mp="3ay3w407a5dmb">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-4957" data-mp="3f1jsqwjcndz0">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-4958" data-mp="3jxijurw2ba34">
            <div className="flex flex-col items-center" data-id="element-4959" data-mp="18d1c9ppp9cya">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4960" data-mp="13dexvcy4xqnw" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4961" data-mp="udihdylwfy3x">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-4962" data-mp="1r398dnuzf34z">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4963" data-mp="1n1o0yi17vh26">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4964" data-mp="1i9w6vxiuqt7a" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4965" data-mp="2asa0fkx5nt0k">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-4966" data-mp="25z8fav6cux8j">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4967" data-mp="2tvlilfak602e">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-4968" data-mp="2txg7t5sv4eca" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4969" data-mp="265hpw2ywrkq6">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-4970" data-mp="2b4kob4kdusp6">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4971" data-mp="1x75p584bv6k0">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-4972" data-mp="1jwu7x3unh8ms">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4973" data-mp="1jxlr1f729dw6">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-4974" data-mp="1fwjsz1ovr7vs">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-4975" data-mp="1ow6rnfq85zl5" />
            <span className="italic" data-id="element-4976" data-mp="1ovnai18eff86">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-4977" data-mp="23ji4rm221rnd">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4978" data-mp="1yn1eal7dv174">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4979" data-mp="2clrei9pi1gzp">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-4980" data-mp="27npy5wjgjvrx"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4981" data-mp="tl8vsmrkw6n2">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4982" data-mp="3s6jw4wzb3u3f">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-4983" data-mp="5x8z767l5m0k"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4984" data-mp="2wv2gsivd34p7">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4985" data-mp="2rx0yi05rf9es">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-4986" data-mp="2nwi7u9fls9e6"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-4987" data-mp="1ujucibh9qwvh">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4988" data-mp="1gjt0bzvk030p">
              <div className="flex items-center mb-4" data-id="element-4989" data-mp="1gm5q2z7jzhob">
                <div className="flex text-green-500 mr-2" data-id="element-4990" data-mp="1ljxkbzvo7fvo">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4991" data-mp="29909dssmwb07" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4992" data-mp="2d9ad0ysyepbw">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4993" data-mp="1zi5kshrx0zbl">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4994" data-mp="2s6b553f24maw">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4995" data-mp="2nd8ou9dj4nx8">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4996" data-mp="2je87ywem3vcv">
              <div className="flex items-center mb-4" data-id="element-4997" data-mp="2xczmgjxdzj1j">
                <div className="flex text-green-500 mr-2" data-id="element-4998" data-mp="2sdd4xyaizgmx">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4999" data-mp="clfs5846kxc5" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5000" data-mp="7nnurykroj0k">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5001" data-mp="223vya3l03lpl">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5002" data-mp="265hk4efijabx">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5003" data-mp="2yr98mp05hh2m">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5004" data-mp="14eswj7kob8pu">
              <div className="flex items-center mb-4" data-id="element-5005" data-mp="wvjn5ec63a0s">
                <div className="flex text-green-500 mr-2" data-id="element-5006" data-mp="wx4gx1qnqoxl">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5007" data-mp="s3080cxu06tv" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5008" data-mp="n3nl5s6ymzra">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5009" data-mp="i4uas8myzovc">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5010" data-mp="1awm79ljlqa92">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5011" data-mp="2d7df8fnzlros">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5012" data-mp="293fjmexvez0h">
              <div className="flex items-center mb-4" data-id="element-5013" data-mp="35texmowsipqg">
                <div className="flex text-green-500 mr-2" data-id="element-5014" data-mp="30xhl6tone3iy">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5015" data-mp="2wti3i7rmsyo0" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5016" data-mp="2rv87xw1zvw1v">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5017" data-mp="1lh8ziub69stw">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5018" data-mp="3s3wx0sd42bt6">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5019" data-mp="4y5x0avsoyt9">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5020" data-mp="ep0jngcye0f8">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5021" data-mp="spbcgoxtpp31">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5022" data-mp="so9pbm3j9c4y">
          <div data-id="element-5023" data-mp="2qfw1w30bsvud">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5024" data-mp="2qgdwywb9540p">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5025" data-mp="1mqxgtbukg02">
              <p data-id="element-5026" data-mp="3ss8uhw9a95cy">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-5027" data-mp="kjiesx7twl1h">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-5028" data-mp="13ai6w7ameayz">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-5029" data-mp="1cy49jbz1po8h">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-5030" data-mp="p78b3w033us9">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5031" data-mp="l9kcoiz6njvm">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5032" data-mp="d5ql7363rg4u" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5033" data-mp="3vk9g30t4ftxe">
        <div className="max-w-md mx-auto px-4" data-id="element-5034" data-mp="3qles7kgarf6f">
          <div className="p-6 rounded-3xl w-full" data-id="element-5035" data-mp="3qn9ass43iv7c">
            <div className="flex justify-center items-center" data-id="element-5036" data-mp="3lmv5vixsk1dj">
              <iframe src={embedUrl} height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5037" data-mp="3looaytsradjf"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5038" data-mp="2ssykfntrs1mg">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5039" data-mp="2xr9unznz8e57">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5040" data-mp="2xox633npr5j6" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5041" data-mp="29u2u4nl187dw">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5042" data-mp="2et70l6gknr0j">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5043" data-mp="2ntc77edxyldn">
            <p className="mb-2" data-id="element-5044" data-mp="3u9ehbxfa4666">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5045" data-mp="3220jjib5uqs">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5046" data-mp="1bi8e898onh6l" />
    </div>;
}